import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_EMAIL, SITE_DOMAIN, SITE_URL } from '../data/site';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <img
              src="/images/logo_son.png"
              alt=""
              className="footer__logo"
              width="46"
              height="46"
            />
            <div>
              <p className="footer__name">Travel Istanbul</p>
              <p className="footer__tagline">İstanbul’u hikâyesiyle gezin.</p>
            </div>
          </div>

          <div className="footer__cols">
            <div className="footer__col">
              <h4>Bağlantılar</h4>
              <ul>
                <li>
                  <Link to="/">Ana Sayfa</Link>
                </li>
                <li>
                  <Link to="/contact">İletişim</Link>
                </li>
              </ul>
            </div>

            <div className="footer__col">
              <h4>Yasal</h4>
              <ul>
                <li>
                  <Link to="/terms">Kullanıcı Sözleşmesi</Link>
                </li>
                <li>
                  <Link to="/privacy">Gizlilik Politikası</Link>
                </li>
                <li>
                  <Link to="/terms-en">Terms of Use (EN)</Link>
                </li>
                <li>
                  <Link to="/privacy-en">Privacy Policy (EN)</Link>
                </li>
              </ul>
            </div>

            <div className="footer__col">
              <h4>İletişim</h4>
              <ul>
                <li>
                  <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                </li>
                <li>
                  <a href={SITE_URL}>{SITE_DOMAIN}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {year} Travel Istanbul. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
